import * as React from 'react'

import { OnlineContext } from './context'
import { IOnlineProps } from './IOnlineProps'

import { Detector } from 'react-detect-offline'

export const withOnlineDetectProvider = <P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P & IOnlineProps> => (props: P) => (
  <Detector
    polling={{
      enabled: true,
      timeout: Number(process.env.REACT_APP_DEFAULT_TIMEOUT)
    }}
    render={({ online }) => (
      <OnlineContext.Provider value={{ online }}>
        <Component {...props} />
      </OnlineContext.Provider>
    )}
  />
)



// WEBPACK FOOTER //
// ./src/components/OnlineDetect/withOnlineDetectProvider.tsx